import React, {Fragment} from "react";
import {detectSqlInjection} from "perfect-express-sanitizer/modules/sql_injection";
import {Modal} from "antd";
import NodeSQLParser from "node-sql-parser";

export const TABLE_CHOICE = "T";
export const VIEW_CHOICE = "V";
export const TABLE_VIEW_CHOICE = "TV";
export const SELECT_TABLE_VIEW_CHOICES = [{label: "Table", value: TABLE_CHOICE}, {
    label: "View",
    value: VIEW_CHOICE
}, {label: "Table/View", value: TABLE_VIEW_CHOICE}];

export const CUBE_CHOICE = "C";
export const DATAFLOW_CHOICE = "F";
export const DATAFLOW_CUBE_CHOICE = "CF";
export const SELECT_DATAFLOW_CUBE_CHOICES = [{label: "DataCube", value: CUBE_CHOICE}, {
    label: "Dataflow",
    value: DATAFLOW_CHOICE
}, {label: "Dataflow/Datacube", value: DATAFLOW_CUBE_CHOICE}];

export const MDM_CHOICE = "MDM";
export const QUERY_HEIGHT = 200;

const aliasIsInvalidHelper = (aliasCols, col) => {
    let checks = aliasCols.filter(a => a.colID !== col.colID && !!a.colValue && !a.fixedValue).map(a => a.colValue);
    return checks.concat(aliasCols.filter(a => !!a.colValue && !!a.fixedValue).map(a => a.colID));

}

export const aliasIsInvalid = (aliasCols, col = null) => {
    if (col && col.fixedValue) {
        return false;
    }
    if (!col) {
        let invalid = false;
        aliasCols.forEach(col => {
            if (!col.fixedValue) {
                let checks = aliasIsInvalidHelper(aliasCols, col);
                if (checks.includes(col.colValue)) {
                    invalid = true;
                }
            }
        });
        return invalid;
    }
    let checks = aliasIsInvalidHelper(aliasCols, col);
    return checks.includes(col.colValue);
}

export const wrapColumnWithDBSpecificParenthesis = (columnName, dbType) => {
    switch (dbType) {
        case 1:
            return columnName;
        case 2:
            return `[${columnName}]`;
        case 3:
            return `"${columnName}"`;
        case 4:
            return `\`${columnName}\``;
        default:
            return columnName;
    }
}

export const endQueryDBSpecific = (dbType) => {
    if (dbType === 3) {
        return ""
    }
    return "AS TEMP_END_QUERY"
}

export const buildWholeSQL = (selectedTables, dbType) => selectedTables.map(t => buildIndividualSQL(t.aliasCols, t.name || t.Code, t.filterStr, dbType)).join("\nUNION\n");

export const buildIndividualSQL = (aliasCols = [], tableViewId, filterStr, dbType, includeFixedValue = true, includeAliases = true) => {
    let cols = aliasCols;
    if (!includeFixedValue) {
        cols = cols.filter(item => !item.fixedValue)
    }
    const fromStr = `FROM ${tableViewId} ${!!filterStr ? `WHERE ${filterStr}` : ""}`;
    if (cols.length === 0) {
        const selectStr = 'SELECT *';
        return `${selectStr} ${fromStr}`
    }
    if (!includeAliases) {
        const selectStr = `SELECT ${cols.map(a => wrapColumnWithDBSpecificParenthesis(a.colID, dbType)).join(", ")}`;
        return `${selectStr} ${fromStr}`
    }
    const selectStr = `SELECT ${cols.map(item => {
        if (item.fixedValue) return `'${item.colValue}' as ${wrapColumnWithDBSpecificParenthesis(item.colID, dbType)}`
        return `${wrapColumnWithDBSpecificParenthesis(item.colID, dbType)}${!!item.colValue ? ` as ${item.colValue}` : ""}`
    }).join(", ")}`;

    return `${selectStr} ${fromStr}`
}

export const isFixedColInvalid = (fixedCol, allIDs, t) => {
    if (!fixedCol.colID) {
        return t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.missingColId');
    }
    if (!fixedCol.colValue) {
        return t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.missingColValue');
    }
    if (allIDs.includes(fixedCol.colID)) {
        return t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.colIDShouldBeUnique');
    }
    return ""
}

export const sqlDoesNotContainBlacklistedKeywords = (test, blacklist = [], t) => {
    if (blacklist.length === 0 || !test) return true;
    const parser = new NodeSQLParser.Parser();
    let ast;
    try {
        ast = parser.astify(test.replace(/[\[\]`]+/g, ""));
    } catch (e) {
        console.log(e);
        return true;
    }

    if (ast.orderby && ast.orderby.length > 0) {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: t('scenes.mappingHandler.DatasetBuilder.wizard.sqlHasOrderBy')
        });
        return false;
    }

    const columns = ast.columns.map(item => item.as || item.expr.column || item.expr.value);
    const blacklistedColumns = columns.filter(item => blacklist.map(blackItem => blackItem.toLowerCase()).includes(item.toLowerCase()));
    if (blacklistedColumns.length > 0) {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: <Fragment><p>{t('scenes.mappingHandler.DatasetBuilder.wizard.sqlHasBlacklistKeywords')}</p><ul>{blacklistedColumns.map(col => <li>{col}</li>)}</ul></Fragment>
        });
        return false;
    }

    return true
}

export const sqlIsValid = (test, t) => {
    const sqlInjTest = detectSqlInjection(test.toLowerCase().replaceAll("'", ""), 3);
    if (sqlInjTest) {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.checkForSQLInjection')
        });
        return false;
    }
    return true
}

export const isForcedChecked = (aliasCols, code) => aliasCols.map(item => item.colID).includes(code);
